import { render, staticRenderFns } from "./person.vue?vue&type=template&id=5af85bd7&scoped=true&"
import script from "./person.vue?vue&type=script&lang=ts&"
export * from "./person.vue?vue&type=script&lang=ts&"
import style0 from "./person.vue?vue&type=style&index=0&id=5af85bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af85bd7",
  null
  
)

export default component.exports